import { jsxs as i, Fragment as $, jsx as e } from "react/jsx-runtime";
import { useState as x, useEffect as E } from "react";
import { FontAwesomeIcon as s } from "@fortawesome/react-fontawesome";
import { faPhone as g, faMobileAlt as M, faBars as B, faChevronDown as G, faMapMarkerAlt as J, faEnvelope as Y, faAngleDoubleUp as q, faCopyright as K } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp as j, faFacebookF as F, faInstagram as H, faYoutube as Q, faTwitter as W, faLinkedin as O, faPinterest as R } from "@fortawesome/free-brands-svg-icons";
import { useTranslation as V } from "react-i18next";
import { Link as N } from "react-router-dom";
import z from "he";
const ie = ({
  agencyData: r,
  languageSelector: t,
  config: o,
  assets: b = {
    logoPath: "/assets/images/logo.png",
    menuItemsPath: "/locales"
  },
  className: L = "",
  showLoader: T = !0,
  onMenuItemClick: u
}) => {
  const [f, l] = x(T), [A, a] = x([]), [S, y] = x(!0), { t: h, i18n: C } = V(), v = C.language, [_, d] = x(!1), [m, p] = x(!1);
  console.log("[SharedHeader] agencyData", r), E(() => {
    if (!T) {
      l(!1);
      return;
    }
    const n = setTimeout(() => {
      l(!1);
    }, 1e3);
    return () => clearTimeout(n);
  }, [T]), E(() => {
    v && (async () => {
      const w = v.split("-")[0];
      if (!w || w.includes("cimode")) {
        a([]), y(!1);
        return;
      }
      y(!0);
      try {
        const c = await fetch(`${b.menuItemsPath}/${w}/menuItems.json`);
        if (!c.ok)
          throw new Error(`HTTP error! status: ${c.status}`);
        const P = await c.json();
        a(P || []);
      } catch (c) {
        console.error(`Failed to load menu items for language: ${w}`, c), a([]);
      } finally {
        y(!1);
      }
    })();
  }, [v, b.menuItemsPath]);
  const U = (n) => {
    p(!1), d(!1), u == null || u(n);
  };
  return /* @__PURE__ */ i($, { children: [
    f && /* @__PURE__ */ e("div", { id: "site-loader", className: "load-complete", children: /* @__PURE__ */ i("div", { className: "load-position", children: [
      /* @__PURE__ */ e("div", { className: "logo logo-block", children: /* @__PURE__ */ e(N, { to: "/", title: `${h("navigation.homeLinkTitle")}`, children: /* @__PURE__ */ e(
        "img",
        {
          src: b.logoPath,
          alt: r.agency_name,
          title: r.agency_name
        }
      ) }) }),
      /* @__PURE__ */ i("div", { className: "loading", children: [
        /* @__PURE__ */ e("div", { className: "loading-line" }),
        /* @__PURE__ */ e("div", { className: "loading-break loading-dot-1" }),
        /* @__PURE__ */ e("div", { className: "loading-break loading-dot-2" }),
        /* @__PURE__ */ e("div", { className: "loading-break loading-dot-3" })
      ] })
    ] }) }),
    /* @__PURE__ */ i("header", { className: `header ${L}`, children: [
      /* @__PURE__ */ e("div", { className: "topbar", children: /* @__PURE__ */ e("div", { className: "container-fluid", children: /* @__PURE__ */ i("div", { className: "row justify-content-between", children: [
        /* @__PURE__ */ i("div", { className: "col-9 col-lg d-flex flex-column flex-sm-row", children: [
          o.agency.showPhone && (o.agency.customPhone !== "" || r.phone1 && r.phone1 !== "N/A") && /* @__PURE__ */ e("div", { className: "d-inline-block mr-sm-4", children: o.agency.customPhone !== "" ? /* @__PURE__ */ i("a", { href: `tel:${r.international_prefix + o.agency.customPhone}`, title: `${h("header.topbar.phoneTitle")}`, children: [
            /* @__PURE__ */ e(s, { icon: g, className: "mr-2", style: { width: "14px" } }),
            /* @__PURE__ */ e("span", { className: "phoneNumber", children: r.international_prefix + " " + o.agency.customPhone })
          ] }) : /* @__PURE__ */ i("a", { href: `tel:${r.international_prefix || ""}${r.phone1}`, title: `${h("header.topbar.phoneTitle")}`, children: [
            /* @__PURE__ */ e(s, { icon: g, className: "mr-2", style: { width: "14px" } }),
            /* @__PURE__ */ e("span", { className: "phoneNumber", children: `${r.international_prefix || ""} ${r.phone1}` })
          ] }) }),
          o.agency.showMobile && (o.agency.customMobile !== "" || r.mobile && r.mobile !== "N/A") && /* @__PURE__ */ e("div", { className: "d-inline-block", children: o.agency.customMobile !== "" ? /* @__PURE__ */ i("a", { href: `tel:${r.international_prefix + o.agency.customMobile}`, title: `${h("header.topbar.mobileTitle")}`, children: [
            /* @__PURE__ */ e(s, { icon: M, className: "mr-2", style: { width: "14px" } }),
            /* @__PURE__ */ e("span", { className: "phoneNumber", children: r.international_prefix + " " + o.agency.customMobile })
          ] }) : /* @__PURE__ */ i("a", { href: `tel:${r.international_prefix || ""}${r.mobile}`, title: `${h("header.topbar.mobileTitle")}`, children: [
            /* @__PURE__ */ e(s, { icon: M, className: "mr-2", style: { width: "14px" } }),
            /* @__PURE__ */ e("span", { className: "phoneNumber", children: `${r.international_prefix || ""} ${r.mobile}` })
          ] }) })
        ] }),
        /* @__PURE__ */ e("div", { className: "col-auto d-flex flex-column flex-sm-row", children: /* @__PURE__ */ i("div", { className: "d-flex align-items-center", children: [
          /* @__PURE__ */ e("div", { className: "social", children: /* @__PURE__ */ i("ul", { className: "list-unstyled d-flex", children: [
            r.whatsapp && /* @__PURE__ */ e("li", { className: "mr-2", children: /* @__PURE__ */ e(
              "a",
              {
                title: `${h("footer.social.whatsappTitle")}`,
                target: "_blank",
                rel: "noopener noreferrer",
                href: o.socialLinks.whatsapp,
                children: /* @__PURE__ */ e(s, { icon: j })
              }
            ) }),
            r.facebook && typeof o.socialLinks.facebook == "string" && /* @__PURE__ */ e("li", { className: "mr-2", children: /* @__PURE__ */ e("a", { href: o.socialLinks.facebook, target: "_blank", rel: "noopener noreferrer", title: `${h("footer.social.facebookTitle")}`, children: /* @__PURE__ */ e(s, { icon: F }) }) }),
            r.instagram && typeof o.socialLinks.instagram == "string" && /* @__PURE__ */ e("li", { className: "mr-2", children: /* @__PURE__ */ e("a", { href: o.socialLinks.instagram, target: "_blank", rel: "noopener noreferrer", title: `${h("footer.social.instagramTitle")}`, children: /* @__PURE__ */ e(s, { icon: H }) }) }),
            r.youtube && typeof o.socialLinks.youtube == "string" && /* @__PURE__ */ e("li", { className: "mr-2", children: /* @__PURE__ */ e("a", { href: o.socialLinks.youtube, target: "_blank", rel: "noopener noreferrer", title: `${h("footer.social.youtubeTitle")}`, children: /* @__PURE__ */ e(s, { icon: Q }) }) }),
            r.twitter && typeof o.socialLinks.twitter == "string" && /* @__PURE__ */ e("li", { className: "mr-2", children: /* @__PURE__ */ e("a", { href: o.socialLinks.twitter, target: "_blank", rel: "noopener noreferrer", title: `${h("footer.social.twitterTitle")}`, children: /* @__PURE__ */ e(s, { icon: W }) }) }),
            r.linkedin && typeof o.socialLinks.linkedin == "string" && /* @__PURE__ */ e("li", { className: "mr-2", children: /* @__PURE__ */ e("a", { href: o.socialLinks.linkedin, target: "_blank", rel: "noopener noreferrer", title: `${h("footer.social.linkedinTitle")}`, children: /* @__PURE__ */ e(s, { icon: O }) }) }),
            r.pinterest && typeof o.socialLinks.pinterest == "string" && /* @__PURE__ */ e("li", { className: "mr-2", children: /* @__PURE__ */ e("a", { href: o.socialLinks.pinterest, target: "_blank", rel: "noopener noreferrer", title: `${h("footer.social.pinterestTitle")}`, children: /* @__PURE__ */ e(s, { icon: R }) }) })
          ] }) }),
          t
        ] }) })
      ] }) }) }),
      /* @__PURE__ */ e("nav", { className: "navbar navbar-static-top navbar-expand-lg header-sticky", children: /* @__PURE__ */ i("div", { className: "container-fluid", children: [
        /* @__PURE__ */ e(
          "button",
          {
            type: "button",
            className: `navbar-toggler ${_ ? "collapsed" : ""}`,
            "aria-controls": "navbarCollapse",
            "aria-expanded": "false",
            "aria-label": "Toggle navigation",
            onClick: () => {
              p(!1), d((n) => !n);
            },
            children: /* @__PURE__ */ e(s, { icon: B })
          }
        ),
        /* @__PURE__ */ e(N, { className: "navbar-brand", to: "/", title: h("navigation.homeLinkTitle"), children: /* @__PURE__ */ e(
          "img",
          {
            className: "img-fluid",
            src: b.logoPath,
            alt: `${h("header.navbar.logoAlt")}`
          }
        ) }),
        /* @__PURE__ */ e("div", { className: `navbar-collapse collapse justify-content-center pr-xl-5 mr-xl-5 ${_ ? "show" : ""}`, id: "navbarCollapse", children: S ? /* @__PURE__ */ e("div", { className: "navbar-nav", children: /* @__PURE__ */ i("span", { className: "nav-link", children: [
          h("common.loading"),
          "..."
        ] }) }) : /* @__PURE__ */ e("ul", { className: "nav navbar-nav", children: A.map((n, w) => /* @__PURE__ */ i("li", { className: `nav-item ${n.dropdown ? "dropdown" : ""}`, children: [
          n.url && n.url !== "#" && !n.dropdown ? /* @__PURE__ */ e(
            N,
            {
              to: n.url,
              title: n.title,
              className: "nav-link",
              onClick: () => U(n),
              children: n.label
            }
          ) : /* @__PURE__ */ i(
            "a",
            {
              href: n.url || "#",
              title: n.title,
              className: `nav-link ${n.dropdown ? "dropdown-toggle" : ""}`,
              role: n.dropdown ? "button" : void 0,
              "aria-haspopup": n.dropdown ? !0 : void 0,
              "aria-expanded": n.dropdown ? !1 : void 0,
              onClick: (c) => {
                c.preventDefault(), p((P) => !P);
              },
              children: [
                n.label,
                n.dropdown && /* @__PURE__ */ e("span", { className: "dropdownchevron ml-1", children: /* @__PURE__ */ e(s, { icon: G, size: "xs" }) })
              ]
            }
          ),
          n.dropdown && n.items && /* @__PURE__ */ e("ul", { className: `dropdown-menu ${m ? "show" : ""}`, "aria-labelledby": `navbarDropdown${w}`, children: n.items.map((c, P) => /* @__PURE__ */ e("li", { children: c.url && !c.url.startsWith("http") ? /* @__PURE__ */ e(
            N,
            {
              to: c.url,
              title: c.title,
              className: "dropdown-item",
              onClick: () => U(c),
              children: c.label
            }
          ) : /* @__PURE__ */ e(
            "a",
            {
              href: c.url || "#",
              title: c.title,
              className: "dropdown-item",
              target: c.url && c.url.startsWith("http") ? "_blank" : void 0,
              rel: c.url && c.url.startsWith("http") ? "noopener noreferrer" : void 0,
              onClick: () => U(c),
              children: c.label
            }
          ) }, P)) })
        ] }, w)) }) })
      ] }) })
    ] })
  ] });
}, k = ({ label: r, icon: t, tel: o, visible: b = !0 }) => b ? /* @__PURE__ */ i("li", { className: "mb-2 d-flex", children: [
  /* @__PURE__ */ e(s, { icon: t, className: "mr-2 mt-1", style: { width: "16px" } }),
  /* @__PURE__ */ e("span", { children: /* @__PURE__ */ e("a", { href: `tel:${o}`, title: r, className: "text-white", children: o }) })
] }) : null, re = ({
  agencyData: r,
  config: t,
  links: o = [],
  className: b = "",
  onBackToTop: L,
  aboutUsContent: T,
  apiConfig: u,
  privacyLinks: f = {
    datiSocietari: "/dati",
    privacy: "/privacy",
    cookies: "/cookies"
  }
}) => {
  var v, _;
  const [l, A] = x(r || {
    address_details: {
      address: "",
      city_name: "",
      city_cap: "",
      province_name: "",
      sigla: ""
    }
  }), { t: a } = V(), S = (d) => {
    d.preventDefault(), L ? L() : window.scrollTo({ top: 0, behavior: "smooth" });
  };
  E(() => {
    if (r || !u) return;
    (async () => {
      try {
        const m = await fetch(`${u.apiBaseUrl}/agency`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ agencyId: Number(u.agencyId) })
        });
        if (!m.ok)
          throw new Error(`HTTP error! status: ${m.status}`);
        const p = await m.json();
        p && p.data ? A(p.data) : console.error("Formato dati agenzia inatteso:", p);
      } catch (m) {
        console.error("Errore nel fetch dei dati agenzia:", m);
      }
    })();
  }, [r, u]);
  const y = [
    { label: a("navigation.homeLinkTitle"), url: "/", title: a("navigation.homeLinkTitle") },
    { label: a("navigation.propertiesLinkTitle"), url: "/immobili", title: a("navigation.propertiesLinkTitle") },
    { label: a("navigation.aboutUsLinkTitle"), url: "/chi-sono", title: a("navigation.aboutUsLinkTitle") },
    { label: a("navigation.contactUsLinkTitle"), url: "/contatti", title: a("navigation.contactUsLinkTitle") }
  ], h = o.length > 0 ? o : y;
  function C(d) {
    return d.charAt(0).toUpperCase() + d.slice(1);
  }
  return /* @__PURE__ */ i("footer", { className: `footer bg-dark space-pt ${b}`, children: [
    /* @__PURE__ */ e("div", { className: "container-fluid", children: /* @__PURE__ */ i("div", { className: "row", children: [
      /* @__PURE__ */ i("div", { className: "col-lg-5 col-md-6 col-sm-12 mb-4 mb-lg-0", children: [
        /* @__PURE__ */ i("div", { className: "footer-contact-info", children: [
          /* @__PURE__ */ e("h5", { className: "text-gold mb-4", children: a("footer.aboutUsSectionTitle") }),
          /* @__PURE__ */ e("p", { className: "mb-0 text-white", dangerouslySetInnerHTML: {
            __html: T || a("homePage.aboutUsSnippet.text1")
          } })
        ] }),
        /* @__PURE__ */ e("br", {}),
        /* @__PURE__ */ e("div", { className: "social d-inline-block", children: /* @__PURE__ */ i("ul", { className: "list-unstyled d-flex flex-wrap", children: [
          l.whatsapp && /* @__PURE__ */ e("li", { className: "mr-3 mb-2", children: /* @__PURE__ */ e(
            "a",
            {
              title: `${a("footer.social.whatsappTitle")}`,
              target: "_blank",
              rel: "noreferrer",
              className: "text-white",
              href: `https://api.whatsapp.com/send?phone=${l.whatsapp.replace(/\D/g, "")}`,
              children: /* @__PURE__ */ e(s, { icon: j, size: "lg" })
            }
          ) }),
          l.facebook && /* @__PURE__ */ e("li", { className: "mr-3 mb-2", children: /* @__PURE__ */ e("a", { href: l.facebook, target: "_blank", rel: "noreferrer", title: `${a("footer.social.facebookTitle")}`, className: "text-white", children: /* @__PURE__ */ e(s, { icon: F, size: "lg" }) }) }),
          l.instagram && /* @__PURE__ */ e("li", { className: "mr-3 mb-2", children: /* @__PURE__ */ e("a", { href: l.instagram, target: "_blank", rel: "noreferrer", title: `${a("footer.social.instagramTitle")}`, className: "text-white", children: /* @__PURE__ */ e(s, { icon: H, size: "lg" }) }) }),
          l.twitter && /* @__PURE__ */ e("li", { className: "mr-3 mb-2", children: /* @__PURE__ */ e("a", { href: l.twitter, target: "_blank", rel: "noreferrer", title: `${a("footer.social.twitterTitle")}`, className: "text-white", children: /* @__PURE__ */ e(s, { icon: W, size: "lg" }) }) }),
          l.linkedin && /* @__PURE__ */ e("li", { className: "mr-3 mb-2", children: /* @__PURE__ */ e("a", { href: l.linkedin, target: "_blank", rel: "noreferrer", title: `${a("footer.social.linkedinTitle")}`, className: "text-white", children: /* @__PURE__ */ e(s, { icon: O, size: "lg" }) }) }),
          l.pinterest && /* @__PURE__ */ e("li", { className: "mr-3 mb-2", children: /* @__PURE__ */ e("a", { href: l.pinterest, target: "_blank", rel: "noreferrer", title: `${a("footer.social.pinterestTitle")}`, className: "text-white", children: /* @__PURE__ */ e(s, { icon: R, size: "lg" }) }) })
        ] }) })
      ] }),
      /* @__PURE__ */ e("div", { className: "col-lg-4 col-md-6 col-sm-12 mb-4 mb-lg-0", children: /* @__PURE__ */ i("div", { className: "footer-contact-info", children: [
        /* @__PURE__ */ e("h5", { className: "text-gold mb-4", children: a("footer.contactSectionTitle") }),
        /* @__PURE__ */ i("ul", { className: "list-unstyled mb-0 text-white", children: [
          t.ui.footer.showAddress && ((v = l.address_details) == null ? void 0 : v.address) && ((_ = l.address_details) == null ? void 0 : _.city_name) && /* @__PURE__ */ i("li", { className: "mb-2 d-flex", children: [
            /* @__PURE__ */ e(s, { icon: J, className: "mr-2 mt-1", style: { width: "16px" } }),
            /* @__PURE__ */ e("span", { children: t.agency.customAddress !== "" ? /* @__PURE__ */ e("span", { dangerouslySetInnerHTML: { __html: t.agency.customAddress } }) : /* @__PURE__ */ i($, { children: [
              C(z.decode(l.address_details.address)) + " - ",
              `${l.address_details.city_cap || ""} ${l.address_details.city_name}`,
              l.address_details.province_name !== l.address_details.city_name ? ` (${l.address_details.sigla})` : ""
            ] }) })
          ] }),
          t.ui.footer.firstTelAfterMobile && /* @__PURE__ */ i($, { children: [
            /* @__PURE__ */ e(
              k,
              {
                icon: g,
                label: a("footer.contact.phoneTitle"),
                tel: t.agency.customPhone !== "" ? `${l.internationalPrefix || "+39"} ${t.agency.customPhone}` : t.ui.footer.showTel1 && l.phone1 ? `${l.internationalPrefix || "+39"} ${l.phone1}` : null,
                visible: t.agency.customPhone !== "" && t.ui.footer.showTel1 || !!l.phone1 && t.ui.footer.showTel1
              }
            ),
            /* @__PURE__ */ e(
              k,
              {
                icon: g,
                label: a("footer.contact.phoneTitle"),
                tel: t.agency.customPhone2 !== "" ? `${l.internationalPrefix || "+39"} ${t.agency.customPhone2}` : t.ui.footer.showTel2 && l.phone2 ? `${l.internationalPrefix || "+39"} ${l.phone2}` : null,
                visible: t.agency.customPhone2 !== "" && t.ui.footer.showTel2 || !!l.phone2 && t.ui.footer.showTel2
              }
            )
          ] }),
          /* @__PURE__ */ e(
            k,
            {
              icon: M,
              label: a("footer.contact.mobileTitle"),
              tel: t.agency.customMobile !== "" ? `${l.internationalPrefix || "+39"} ${t.agency.customMobile}` : l.mobile && l.mobile !== "N/A" ? `${l.internationalPrefix || "+39"} ${l.mobile}` : null,
              visible: t.agency.customMobile !== "" && t.ui.footer.showMobile1 || !!l.mobile && l.mobile !== "N/A" && t.ui.footer.showMobile1
            }
          ),
          /* @__PURE__ */ e(
            k,
            {
              icon: M,
              label: a("footer.contact.mobileTitle"),
              tel: t.agency.customMobile2 !== "" ? `${l.internationalPrefix || "+39"} ${t.agency.customMobile2}` : l.mobile2 && l.mobile2 !== "N/A" ? `${l.internationalPrefix || "+39"} ${l.mobile2}` : null,
              visible: t.agency.customMobile2 !== "" && t.ui.footer.showMobile2 || !!l.mobile2 && l.mobile2 !== "N/A" && t.ui.footer.showMobile2
            }
          ),
          !t.ui.footer.firstTelAfterMobile && /* @__PURE__ */ i($, { children: [
            /* @__PURE__ */ e(
              k,
              {
                icon: g,
                label: a("footer.contact.phoneTitle"),
                tel: t.agency.customPhone !== "" ? `${l.internationalPrefix || "+39"} ${t.agency.customPhone}` : t.ui.footer.showTel1 && l.phone1 ? `${l.internationalPrefix || "+39"} ${l.phone1}` : null,
                visible: t.agency.customPhone !== "" && t.ui.footer.showTel1 || !!l.phone1 && t.ui.footer.showTel1
              }
            ),
            /* @__PURE__ */ e(
              k,
              {
                icon: g,
                label: a("footer.contact.phoneTitle"),
                tel: t.agency.customPhone2 !== "" ? `${l.internationalPrefix || "+39"} ${t.agency.customPhone2}` : t.ui.footer.showTel2 && l.phone2 ? `${l.internationalPrefix || "+39"} ${l.phone2}` : null,
                visible: t.agency.customPhone2 !== "" && t.ui.footer.showTel2 || !!l.phone2 && t.ui.footer.showTel2
              }
            )
          ] }),
          t.ui.footer.showEmail && l.email && /* @__PURE__ */ i("li", { children: [
            /* @__PURE__ */ e(s, { icon: Y, className: "mr-2 mt-2" }),
            /* @__PURE__ */ e("span", { children: /* @__PURE__ */ e("a", { href: `mailto:${t.agency.customEmail}`, title: a("footer.contact.emailTitle"), className: "text-white", children: t.agency.customEmail }) })
          ] })
        ] })
      ] }) }),
      /* @__PURE__ */ e("div", { className: "col-lg-3 col-md-6 col-sm-12 mb-4 mb-lg-0", children: /* @__PURE__ */ i("div", { className: "footer-link", children: [
        /* @__PURE__ */ e("h5", { className: "text-gold mb-4", children: a("footer.linksSectionTitle") }),
        /* @__PURE__ */ e("ul", { className: "list-unstyled mb-3", children: h.map((d, m) => /* @__PURE__ */ e("li", { children: d.external || d.url.startsWith("http") ? /* @__PURE__ */ e("a", { href: d.url, title: d.title || d.label, target: "_blank", rel: "noreferrer", className: "text-white", children: d.label }) : /* @__PURE__ */ e(N, { to: d.url, title: d.title || d.label, className: "text-white", children: d.label }) }, m)) }),
        l.widgetExternalLinks && /* @__PURE__ */ e("div", { className: "external-links-widget text-white mb-3", dangerouslySetInnerHTML: { __html: l.widgetExternalLinks } }),
        t.ui.footer.showExternalLink && /* @__PURE__ */ e("ul", { className: "list-unstyled", children: /* @__PURE__ */ e("li", { children: /* @__PURE__ */ e("a", { href: "https://www.casagest24.it", title: `${a("footer.titleCasaGest24Link")}`, target: "_blank", rel: "noreferrer", className: "text-white", children: a("footer.externalLinks.casagest24") }) }) })
      ] }) })
    ] }) }),
    /* @__PURE__ */ e("div", { className: "footer-bottom", children: /* @__PURE__ */ e("div", { className: "container", children: /* @__PURE__ */ i("div", { className: "row align-items-center", children: [
      /* @__PURE__ */ i("div", { className: "col-md-5 text-center text-md-left", children: [
        l.ragioneSociale ? /* @__PURE__ */ i("p", { className: "mb-1 text-white", children: [
          z.decode(l.ragioneSociale),
          " ",
          l.vat ? `- ${a("common.partitaIVA")} ${l.vat}` : ""
        ] }) : l.vat ? /* @__PURE__ */ e("p", { className: "mb-1 text-white", children: `${a("common.partitaIVA")} ${l.vat}` }) : null,
        f.datiSocietari && /* @__PURE__ */ i($, { children: [
          /* @__PURE__ */ e(N, { to: f.datiSocietari, title: `${a("footer.datiSocietariLinkTitle")}`, children: a("footer.datiSocietariLinkTitle") }),
          " | "
        ] }),
        f.privacy && /* @__PURE__ */ i($, { children: [
          /* @__PURE__ */ e(N, { to: f.privacy, title: `${a("footer.privacyLinkTitle")}`, children: a("footer.privacyLinkTitle") }),
          " | "
        ] }),
        f.cookies && /* @__PURE__ */ e(N, { to: f.cookies, title: `${a("footer.cookiesLinkTitle")}`, children: a("footer.cookiesLinkTitle") })
      ] }),
      /* @__PURE__ */ e("div", { className: "col-md-2 text-center mb-3 mb-md-0", children: /* @__PURE__ */ e(
        "a",
        {
          id: "back-to-top",
          className: "back-to-top",
          title: `${a("footer.backToTopTitle")}`,
          onClick: S,
          style: { cursor: "pointer" },
          children: /* @__PURE__ */ e(s, { icon: q, size: "lg" })
        }
      ) }),
      /* @__PURE__ */ e("div", { className: "col-md-5 text-center text-md-right", children: /* @__PURE__ */ i("p", { className: "mb-0 text-white", children: [
        /* @__PURE__ */ e(s, { icon: K }),
        " ",
        t.copyright.year,
        " ",
        t.copyright.companyUrl ? /* @__PURE__ */ e("a", { href: t.copyright.companyUrl, title: `${a("footer.copyrightAgencyTitle")}`, target: "_blank", rel: "noopener noreferrer", children: t.copyright.companyName }) : t.copyright.companyName,
        " ",
        a("footer.allRightsReserved")
      ] }) })
    ] }) }) }),
    /* @__PURE__ */ i("div", { className: "line-bg", children: [
      /* @__PURE__ */ e("div", { className: "cover-sx" }),
      /* @__PURE__ */ e("div", { className: "cover-dx" })
    ] })
  ] });
};
export {
  re as Footer,
  ie as Header
};
